<div class="com-popup" [ngClass]="{'com-popup-web': factorySer.isWebStyle}">
  <div class="com-pop-box">
    <div class="cp-title font18-sem">
      {{popTitle | acpText}}
      <span *ngIf="factorySer.isWebStyle && showClose" class="cp-close" (click)="gotoNext('cancel')"></span>
    </div>
    <div class="cp-btm-box">
      <ng-container *ngIf="innerFlag else GenHtml">
        <div class="cp-desc font14-reg cp-desc-inner"[innerHTML]="descPip? (popDesc | acpText) : popDesc"></div>
      </ng-container>
      <ng-template #GenHtml>
        <div class="cp-desc font14-reg">{{descPip? (popDesc | acpText) : popDesc}}</div>
      </ng-template>

      <ng-container *ngIf="showBtn">
        <div class="cp-btn-line">
          <com-btn
            [label]="popBtn1" [actionFlag]=false 
            (click)="gotoNext('01')">
          </com-btn>
          <ng-container *ngIf="popBtn2">
            <com-btn class="cp-btn" 
              [label]="popBtn2" [actionFlag]=false  [whiteBg]=true 
              [fill]="popBtn2Fill || 'outline'"
              (click)="gotoNext('02')">
            </com-btn>
          </ng-container>
          <ng-container *ngIf="showBtn3 && popBtn3">
            <com-btn class="cp-btn"
              fill="none" [label]="popBtn3" 
              [actionFlag]=false (click)="gotoNext('cancel')">
            </com-btn>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>